module.exports = __webpack_public_path__ + "img/1547862048.ff1980ef.jpg";